import { useDeviceCondition } from '../../../../../../hooks';
import { InlineText1, InlineText2 } from '@cian/ui-kit';
import successIcon from '../../assets/success.svg';
import * as styles from '../../PaymentStatus.css';
import * as React from 'react';

export const PaymentStatusSucceeded = () => {
  const InlineText = useDeviceCondition(InlineText2, InlineText1);

  return (
    <>
      <img src={successIcon} className={styles['icon']} data-mark="icon|success" />
      <div className={styles['text']}>
        <InlineText>Платёж успешно выполнен</InlineText>
      </div>
    </>
  );
};
